import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=1db04e39&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=ts&"
export * from "./Recommend.vue?vue&type=script&lang=ts&"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=1db04e39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db04e39",
  null
  
)

export default component.exports